<template>
  <div class="category-list-wrap" v-on-display="{sectionInfo, context: this}">
    <span v-html="title"></span>
    <ul>
      <li v-for="(menuItem, index) in cellList" :key="index" data-recommend-category="true">
        <a @click.prevent.capture="goCategory(menuItem)" href="#" v-title-list="{titleList: getCategoryMenuTitleList(menuItem)}" data-gnb="category-menu"></a>
      </li>
    </ul>
  </div>
</template>

<script>
import categoryMenuMixin from '@/mixins/category.menu.mixin'
export default {
  name: 'CategoryMenuGroup.vue',
  mixins: [categoryMenuMixin],
  data () {
    return {
      duplicationClickTimer: null
    }
  }
}
</script>
